import actionTypes from './actionTypes';
import deleteFaqItemByUuid from '../../helpers/deleteFaqItemByUuid';

const initialState = {
	documents: [],
	projects: {
		limit: 6,
		offset: 0,
		result: [],
		selected: undefined,
	},
	references: [],
	faq: [],
	category: [],
	testimonies: [],
	users: [],
	atex: [],
	isFetching: false,
	fetchingFailed: false,
	fetchingSucceeded: false,
};

export default function contentReducer(state = initialState, action) {
	switch (action.type) {
		case actionTypes.FETCH_DOCUMENTS:
			return {
				...state,
				documents: action.data,
			};
		case actionTypes.SEARCH_DOCUMENTS:
			return {
				...state,
				documents: action.data,
			};
		case actionTypes.FETCH_PROJECTEN:
			return {
				...state,
				projects: {
					...state.projects,
					result: action.data,
				},
			};
		case actionTypes.SEARCH_PROJECTS:
			return {
				...state,
				projects: {
					...state.projects,
					result: action.data,
				},
			};
		case actionTypes.FETCH_PROJECT_DETAIL:
			return {
				...state,
				projects: {
					...state.projects,
					selected: action.data,
				},
			};
		case actionTypes.FETCH_TESTIMONIES:
			return {
				...state,
				testimonies: action.data,
			};
		case actionTypes.FETCH_REFERENCES:
			return {
				...state,
				references: action.data,
			};
		case actionTypes.FETCH_FAQ:
			return {
				...state,
				faq: action.data,
			};
		case actionTypes.FETCH_FAQ_BY_ID:
			return {
				...state,
				faq: action.data,
			};
		case actionTypes.FETCH_CATEGORIES:
			return {
				...state,
				category: action.data,
			};
		case actionTypes.SEARCH_ATEX:
			return {
				...state,
				atex: action.data,
			};
		case actionTypes.FETCHING_IN_PROGRESS:
			return {
				...state,
				isFetching: true,
				fetchingFailed: false,
				fetchingSucceeded: false,
			};
		case actionTypes.FETCHING_FAILED:
			return {
				...state,
				isFetching: false,
				fetchingFailed: true,
			};
		case actionTypes.FETCHING_SUCCEEDED:
			return {
				...state,
				isFetching: false,
				fetchingSucceeded: true,
			};
		case actionTypes.FETCH_USERS:
			return {
				...state,
				users: action.data,
			};
		case actionTypes.REMOVE_DOCUMENT:
			return {
				...state,
				documents: state.documents.filter(doc => doc.uuid !== action.id),
			};
		case actionTypes.REMOVE_REFERENCE:
			return {
				...state,
				references: state.references.filter(ref => ref.uuid !== action.id),
			};
		case actionTypes.REMOVE_PROJECT:
			return {
				...state,
				projects: {
					...state.projects,
					result: state.projects.result.filter(ref => ref.id !== action.id),
				},
			};
		case actionTypes.REMOVE_FAQ:
			return {
				...state,
				faq: state.faq.filter(faq => faq.id !== action.id),
			};
		case actionTypes.REMOVE_FAQ_ITEM:
			return {
				...state,
				faq: deleteFaqItemByUuid({ faqs: state.faq, id: action.id }),
			};
		default:
			return state;
	}
}



// WEBPACK FOOTER //
// ./src/redux/content/contentReducer.js